/**
 * Product Form Components
 *
 */

// Show gallery immediately - run as soon as script loads
(function() {
  function showGallery() {
    const imageGallery = document.querySelector('.product-images-wrapper');
    const productContainer = document.querySelector('[data-product-container]');
    const isSingleVariant = productContainer && productContainer.closest('.main-product-container').classList.contains('only-default-variant');
    
    // For single-variant products, don't show gallery immediately - let the metafield logic handle it
    if (isSingleVariant) {
      return;
    }
    
    if(imageGallery) {
      imageGallery.classList.add('loader-ready');
    }
  }

  // Try to show immediately if DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', showGallery);
  } else {
    showGallery();
  }

  // Fallback: try again after a short delay to catch edge cases
  setTimeout(showGallery, 10);
})();
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.qtyBtns = this.querySelectorAll('[data-qty-btn]');
    this.cartElement = document.querySelector('cart-form');   
  }

  connectedCallback() {
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    if(this.querySelector('[data-qty-container]')){
      this.qtyBtns.forEach(qtyBtn => qtyBtn.addEventListener('click', this.manageQtyBtn.bind(this)));
    }
  }

  /**
   * Product Form Submit event
   *
   * @param {evt} Event instance
   */
  onSubmitHandler(evt) {
    evt.preventDefault();
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');
    submitButton.setAttribute('reyjay', 'testing3');
    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(Utility.serializeForm(this.form)));
    const body = JSON.stringify({
      items: addItems,
      sections: `${((window.globalVariables.template == 'cart') ? 'template-cart' : 'component-cart-drawer')},header` 
    });
    
    fetch(`${routes.cart_add_url}`, { ...Utility.fetchConfig(), body })
    .then((response) => response.json())
    .then((res) => {
      let dataJSON = ((typeof res == 'object') ? res : JSON.parse(res));
      if(dataJSON.errors){
        window.notificationEle.updateNotification('Add to Cart', dataJSON.errors, {
          type: 'error',
          timeout: 5000
        });
        return;
      }

      document.querySelectorAll('[data-atc-out]')?.forEach(ele => {
        ele.setAttribute('disabled', false);
        ele.classList.remove('loading');
      });

      if(qtyInput) qtyInput.value = 1;

      if(this.cartElement){
        this.cartElement._updateCart(dataJSON.sections, 'open_drawer');
      }else{
        // window.location.href = window.routes.cart_fetch_url;

      }      
    })
    .catch((e) => {
      window.notificationEle.updateNotification('Error', e, {
        type: 'error',
        timeout: 5000
      });
      console.error(e);
    })
    .finally(() => {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('disabled');
      // document.querySelector("#checkout").removeAttribute("disabled");
    });
  }

  /**
   * Product Form Quantity Input update action
   *
   * @param {event} Event instance
   */
  manageQtyBtn(event) {
    event.preventDefault();
    let currentTarget = event.currentTarget;
    let action = currentTarget.dataset.for || 'increase';
    let $qtyInput = currentTarget.closest('[data-qty-container]').querySelector('[data-qty-input]');
    let currentQty = parseInt($qtyInput.value) || 1;
    let finalQty = 1;
    let decreaseQtyBtn = currentTarget.closest('[data-qty-container]').querySelector('[data-for="decrease"]');

    if(action == 'decrease' && currentQty <= 1){
      if(decreaseQtyBtn) decreaseQtyBtn.classList.add('disabled');
      return false;
    } else if(action == 'decrease'){
      finalQty = currentQty - 1;
      finalQty == 1 ? decreaseQtyBtn.classList.add('disabled') : decreaseQtyBtn.classList.remove('disabled');
    } else {
      if(decreaseQtyBtn) decreaseQtyBtn.classList.remove('disabled');
      finalQty = currentQty + 1;
    }

    $qtyInput.value = finalQty;
  }
}
customElements.define('product-form', ProductForm);

/**
 * Dropdown selection for options
 */
class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form') || this.closest('.form-element');
    this.formType = this.form.dataset.format;
    this.addBtn = this.form.querySelector('[name="add"]');
    this.variant_json = this.form.querySelector('[data-variantJSON]');
    this.variant_metafield = this.form.querySelector('[data-variantJSON-metafields]');
    this.variantPicker = this.dataset.type;
  }

  connectedCallback() {
    // Show loader immediately for product pages - before any other processing
    if(this.formType == 'product-page') {
      this.showLoader();
    }
    
    // Element Connected callback
    if(this.formType == 'product-page') {
      this.onVariantChange('load');
      // Handle URL parameters for direct variant access
      this.handleUrlVariantParameter();
      
      // Handle single-variant products to default to second image if metafield is set
      this.handleSingleVariantSecondImage();
      
      // Fallback to ensure gallery always shows quickly
      setTimeout(() => {
        this.hideLoader();
      }, 100);
    }
    this.addEventListener('change', this.onVariantChange.bind(this));
  }

  /**
   * Trigger this function variant is changed
   * @param {event} _event 
   */
  onVariantChange(_event) {
    this.setCurrentVariant();

    if(this.formType == 'product-page') window.globalVariables.product.currentVariant = this.currentVariant;
    document.dispatchEvent(new Event('variant:changed'));
    
    if (!this.currentVariant) {
      this.toggleAddButton('disable');
      this.updateOptionLabel(this.form); 
    } else {
      if(this.formType == 'grid'){
        const productGrid = this.closest('[data-product-grid]');
        this.renderProductInfo(this.currentVariant, productGrid, _event);
        this._updateLinks(productGrid); 
      }else{
        const productPage = this.closest('[data-product-container]');
        const container = this.closest('[data-subscription-form]') ? this.closest('[data-subscription-form]') : productPage;
        this.renderProductInfo(this.currentVariant, container, _event);
      }

      this.updateURLandID(this.currentVariant);

      if (this.form.querySelectorAll('[data-onetime-price]').length) {
        this.form.querySelectorAll('[data-onetime-price]').forEach((ele)=>{
          ele.innerHTML = Utility.formatMoney(this.currentVariant.price, window.globalVariables.money_format);
        });
      }
    
      if(this.form.querySelector('[data-onetimes-price]')) {
        this.form.querySelector('[data-onetimes-price]').innerHTML = Utility.formatMoney(this.currentVariantGroup[0].price, window.globalVariables.money_format);
      }

      // Set onetime_compare_price attribute on page load and variant changes
      this.form.querySelectorAll('[data-onetime-price]').forEach((ele)=>{
        let comparePrice = null;
        
        // Check selling_plan_allocations first, then regular compare_at_price
        if (this.currentVariant.selling_plan_allocations && this.currentVariant.selling_plan_allocations.length > 0 && this.currentVariant.selling_plan_allocations[0].compare_at_price) {
          comparePrice = this.currentVariant.selling_plan_allocations[0].compare_at_price;
        } else if (this.currentVariant.compare_at_price != null) {
          comparePrice = this.currentVariant.compare_at_price;
        }
        
        if (comparePrice != null) {
          let onetime_com_price = Utility.formatMoney(comparePrice, window.globalVariables.money_format);
          ele.setAttribute("onetime_compare_price", onetime_com_price);
        } else {
          ele.setAttribute("onetime_compare_price", "");
        }
      });

      if(_event != 'load') {
        // Update Supply
        if(this.formType == 'product-page'){
          _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-subscription_price]').forEach((ele)=>{
            let subscription_price = Utility.formatMoney(this.currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
            if (ele.closest('[data-select-subscription_price]')) {
              let text = ele.innerText.split(window.globalVariables.money_format.replaceAll('{{amount}}',''));
              ele.innerText = `${text[0]} ${subscription_price}`;
            } else {
              ele.innerHTML = subscription_price;
            }

            if(this.currentVariant.compare_at_price != null){
              let subscription_compare = Utility.formatMoney(this.currentVariant.compare_at_price, window.globalVariables.money_format);
              ele.setAttribute("subscription_compare_price", subscription_compare);  
            } else {
              let subscription_compare = Utility.formatMoney(this.currentVariant.selling_plan_allocations[0].compare_at_price, window.globalVariables.money_format);
              ele.setAttribute("subscription_compare_price", subscription_compare);
            }
          });
        }
        
        // Update onetime price
        _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-onetime-price]').forEach((ele)=>{
          let onetime_price = Utility.formatMoney(this.currentVariant.price, window.globalVariables.money_format);
          ele.innerHTML = onetime_price;
        });

        // Update onetime discount striked price
        _event.target?.closest('[data-product-container]')?.querySelectorAll('[data-onetime-discount-striked]').forEach((ele)=>{
          if(this.currentVariant.compare_at_price > this.currentVariant.price){
            let originalPrice = Utility.formatMoney(this.currentVariant.compare_at_price, window.globalVariables.money_format);
            ele.innerHTML = originalPrice;
          }else{
            ele.innerHTML = '';
          }
        });

        if (this.form.querySelector('recharge-widget')) {
          // Filter selling plans based on current variant
          const rechargeWidget = this.form.querySelector('recharge-widget');
          if (rechargeWidget && typeof rechargeWidget.filterSellingPlansForVariant === 'function') {
            rechargeWidget.filterSellingPlansForVariant();
          }
          
          // Call methods directly on the recharge widget instance
          if (rechargeWidget && typeof rechargeWidget._toggleOptions === 'function') {
            rechargeWidget._toggleOptions(_event);
          }
          if (rechargeWidget && typeof rechargeWidget._changeSellingPlan === 'function') {
            rechargeWidget._changeSellingPlan(_event);
          }
          let selectedItemType = this.form.querySelector('[data-purchase_type] input:checked')?.getAttribute('data-type') || 'onetime';
          if (selectedItemType == 'onetime') {
            const onetimePriceElement = this.form.querySelector('[data-onetime-price]');
            const currentPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-currentprice]');
            if (onetimePriceElement && currentPriceElement) {
              let onetime_price = onetimePriceElement.innerHTML;
              currentPriceElement.innerHTML = onetime_price;
            }
          } else {
            let subscription_price = this.form.querySelector('[data-subscription_price]').innerHTML;
            this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = subscription_price;

            if(this.form.querySelector(".selling_plan li.selected input") != null){
              let subscription_plan_id = document.querySelector(".selling_plan li.selected input").value;
              this.form.querySelector('.subscritpion_box input[name="selling_plan"]').value = subscription_plan_id;
            }
          }
        }

      }

      // Calculate total savings including compare at price discount
      const rechargeInput = this.form.querySelector('recharge-widget custom-select ul li input');
      let disV = rechargeInput ? rechargeInput.getAttribute('data-discount') : 0;

      const comparePrice = this.currentVariant.compare_at_price > this.currentVariant.price ? this.currentVariant.compare_at_price : this.currentVariant.price;
      const finalPrice = this.currentVariant.price - (this.currentVariant.price * disV / 100);
      const totalSavingsPercentage = Math.floor(((comparePrice - finalPrice) / comparePrice) * 100);

      // Calculate total discount amount (compare price discount + Recharge discount + shipping)
      const comparePriceDiscount = comparePrice - this.currentVariant.price;  // Savings from compare price
      let vPrice = this.currentVariant.price * disV / 100;  // Recharge discount
      let ship_rate = this.currentVariant.metafields.shipping_rate * 100 || 0;
      let totalDis = Utility.formatMoney((comparePriceDiscount + ship_rate + vPrice), window.globalVariables.money_format);

      const shippingTextElement = this.form.querySelectorAll('[data-shipping-text]');
      
      if(shippingTextElement) {
        shippingTextElement.forEach(element => {
          if((ship_rate + vPrice) > 0) {
            element.innerHTML = `${totalSavingsPercentage}% off + Free Shipping*<br/> ${totalDis} Total Savings`;
          } else {
            element.innerHTML = ' ';
          }
        });
      }
      

      // Update future subscription price (10% off compare_at_price)
      const futureSubscriptionPriceElement = document.querySelector('[data-future-subscription-price]');
      if (futureSubscriptionPriceElement) {
        const comparePriceText = this.form.querySelector('[data-onetime-price]').getAttribute("onetime_compare_price");
        if (comparePriceText && comparePriceText.length > 0) {
          const comparePrice = parseFloat(comparePriceText.replace('$', '').replace(',', ''));
          const futureSubscriptionPrice = comparePrice * 0.9; // 10% off compare price
          futureSubscriptionPriceElement.textContent = Utility.formatMoney(futureSubscriptionPrice * 100, window.globalVariables.money_format);
        }
      }

      this.toggleAddButton('enable');
    }
  }

  /**
   * Change product variant url link in product card when variant is being updated
   * @param {element} productGrid 
   */
  _updateLinks(productGrid){
    if(!this.currentVariant || !productGrid) return;
    const variantURL = `?variant=${this.currentVariant.id}`;
    const formLinks = productGrid.querySelectorAll('.product-link');
    formLinks.forEach(link => {
      let href = link.href.split('?')[0];
      link.href = href + variantURL;
    });
  }

  /**
   * Fetch selected options from dropdown
   */
  _getOptionsFromSelect() {
    let options = [];
    this.querySelectorAll('.variant_selector').forEach((selector)=>{
      options.push(selector.value);
    });
    return options;
  }

  /**
   * Fetch selected options from radio
   */
  _getOptionsFromRadio() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset:not(.addon-fieldset)'));
    return fieldsets.map((fieldset) => {
      const checkedRadio = Array.from(fieldset.querySelectorAll('input:not(.addon-swatch)')).find((radio) => radio.checked);
      return checkedRadio ? checkedRadio.value : null;
    });
  }

  /**
   * change value of currentVariant when variant being changed 
   */
  setCurrentVariant() {
    this.currentVariant = false;
    this.currentVariantGroup = false;
    let options = (this.variantPicker == 'variant-select') ? this._getOptionsFromSelect() : this._getOptionsFromRadio();
    let variantsArray = this._getVariantData();
    
    let mappedValuesJson = [];
    variantsArray.find((variant) => {
      let mappedValues = variant.options.map((option, index) => {
        return options[index] === option;
      });

      if(variant.options[0] === options[0]) {
        mappedValuesJson.push(variant);
      }

      if(!mappedValues.includes(false)) {
        this.currentVariant = variant;
      }
    });
    this.currentVariantGroup = mappedValuesJson;
  }

  /**
   * Update selected option name label
   */
  updateOptionLabel(form){
    let options = form.querySelectorAll('[data-optionindex]');
    options.forEach(option => {
      let labelID = 'option'+option.dataset.optionindex;
      const label = option.querySelector('.selected-option');
      if(!label || !labelID) return;
      label.textContent = this.currentVariant[labelID];
    });
  }

  /**
   * Update URL on variant change event
   * @param {JSON} currentVariant 
   */
  updateURLandID(currentVariant) {
    if (!currentVariant) return;

    if(this.formType == 'product-page') {
      window.history.replaceState({ }, '', `${this.dataset.url}?variant=${currentVariant.id}`);
    }

    const input = this.form.querySelector('input[name="id"]');
    input.value = currentVariant.id;
  }

  /**
   * Update first-order pricing display based on variant selling plan allocations
   * @param {object} currentVariant 
   * @param {element} container 
   */
  updateFirstOrderPricing(currentVariant, container) {
    
    const firstOrderPricingElement = container.querySelector('[data-first-order-pricing]');
    if (!firstOrderPricingElement) return;

    // Check if variant has selling plan allocations with price adjustments
    if (currentVariant.selling_plan_allocations && 
        currentVariant.selling_plan_allocations.length > 0) {
      
      const firstAllocation = currentVariant.selling_plan_allocations[0];

             // This is the metafield we set on the variant level to provide the discount amount after the firest order for subs
       const futureOrderDiscount = currentVariant.metafields.future_order_hardcoded_discount;
       
       if (futureOrderDiscount) {
         // Use metafield override
         this._displayFirstOrderPricingWithOverride(firstOrderPricingElement, firstAllocation, currentVariant, futureOrderDiscount);
       } else if (firstAllocation.price_adjustments && firstAllocation.price_adjustments.length >= 2) {
         // Use normal Recharge logic
         this._displayFirstOrderPricingNormal(firstOrderPricingElement, firstAllocation, currentVariant);
       } else {
         // No price adjustments - hide the element
         firstOrderPricingElement.style.display = 'none';
       }
    } else {
      // No selling plan allocations - hide the element
      firstOrderPricingElement.style.display = 'none';
    }
  }

  /**
   * Update product pricing based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  priceUpdate(currentVariant, container){
    
    let regularP = currentVariant.price;
    // Handle both case variations of data-currentPrice
    const priceElement = container.querySelector('[data-currentPrice]') || container.querySelector('[data-currentprice]');
    const comparePriceElement = container.querySelector('[data-current-com-price]');

    
    if (priceElement) {
      priceElement.textContent = Utility.formatMoney(regularP, window.globalVariables.money_format);
    }

    let compareP = currentVariant.compare_at_price;
    
    if(compareP != null && comparePriceElement){
      const formattedComparePrice = Utility.formatMoney(compareP, window.globalVariables.money_format);
      comparePriceElement.textContent = formattedComparePrice;
      
      // Check if there's a real discount for display styling
      const hasRealDiscount = compareP > regularP;
      
      if (priceElement) {
        if (hasRealDiscount) {
          priceElement.classList.add('text-danger');
          comparePriceElement.style.display = '';
        } else {
          priceElement.classList.remove('text-danger');
          comparePriceElement.style.display = 'none';
        }
      }
    } else if (comparePriceElement) {
      // No compare price, hide the crossed-out price and remove red styling
      comparePriceElement.style.display = 'none';
      if (priceElement) {
        priceElement.classList.remove('text-danger');
      }
    }

    if(this.formType == 'product-page'){
      // Check if this is a subscription product (has recharge widget)
      const checkedInput = this.form.querySelector('.widget-options input:checked');
      
      if (checkedInput) {
        // This is a subscription product
        const purchaseType = checkedInput.closest('[data-purchase_type]');
        if (!purchaseType) return;
      
        const planType = purchaseType.getAttribute('data-purchase_type');
      
        if(planType == 'subscription') {
          let dis = this.form.querySelector('recharge-widget custom-select ul li input').getAttribute('data-discount') || 0;
          let discountPercentage = parseFloat(dis); 
          let discountedPrice = regularP - (regularP * discountPercentage / 100);
          
          // Round to nearest cent to match Recharge/Shopify backend rounding
          discountedPrice = Math.round(discountedPrice);
          
          if (priceElement) {
            priceElement.textContent = Utility.formatMoney(discountedPrice, window.globalVariables.money_format);
          }

          let subscriptionCompareP = currentVariant.selling_plan_allocations[0].compare_at_price;
          if(subscriptionCompareP != null && comparePriceElement) {
            comparePriceElement.textContent = Utility.formatMoney(subscriptionCompareP, window.globalVariables.money_format);
            
            // Check if there's a real discount for subscription
            const hasSubscriptionDiscount = subscriptionCompareP > discountedPrice;
            
            if (priceElement) {
              if (hasSubscriptionDiscount) {
                priceElement.classList.add('text-danger');
                comparePriceElement.style.display = '';
              } else {
                priceElement.classList.remove('text-danger');
                comparePriceElement.style.display = 'none';
              }
            }
          }
        }
      }
      // If no checked input found, this is a non-subscription product and we've already handled it above
    }
    
    // Update first-order pricing display
    this.updateFirstOrderPricing(currentVariant, container);
  }

  /**
   * Render Product data based on current variant
   * @param {object} currentVariant 
   * @param {element} container 
   */
  renderProductInfo(currentVariant, container, eventType) {
    if(!currentVariant || !container) {
      return;
    }

    this.updateOptionLabel(this.form); 

    // Handle variant image visibility for product pages
    if(this.formType == 'product-page') {
      this.updateVariantImageVisibility(currentVariant);
    }

    // Check if variant has alternate main image, otherwise use featured image
    let imageToUse = currentVariant.featured_image;
    let mediaIdToUse = currentVariant.featured_media ? currentVariant.featured_media.id : null;
    
    // Check for alternate main image in metafields
    if(currentVariant.metafields && 
       currentVariant.metafields.alternate_main_image && 
       currentVariant.metafields.alternate_main_image.src) {
      imageToUse = currentVariant.metafields.alternate_main_image;
      mediaIdToUse = `alternate-${currentVariant.id}`;
    }
    
    if(imageToUse != null && this.formType != 'subscription') {
      if(this.formType == 'grid') {
        const featuredImage = container.querySelector('[data-feauredImage]');
        featuredImage.src = imageToUse.src;
        featuredImage.srcset = imageToUse.src;
      } else {
        let imageSlide = document.querySelector(`.product--media[data-mediaID="${mediaIdToUse}"]`);        
        
        if(!imageSlide) {
          return;
        }
  
        let slideIndex = Array.from(imageSlide.parentNode.children).indexOf(imageSlide);
        if(productSlider) {
          productSlider.slideTo(slideIndex, 0, false);
        }
      }
    }

    if(this.formType == 'product-page') {
      // Check if this product has subscription options (widget-options)
      const widgetOptions = this.form.querySelector('.widget-options input:checked');
      
      let planType = 'onetime'; // Default for non-subscription products
      let discountPercentage = 0;
      
      if (widgetOptions) {
        // This is a subscription product
        const purchaseType = widgetOptions.closest('[data-purchase_type]');
        if (purchaseType) {
          planType = purchaseType.getAttribute('data-purchase_type');
          let dis = planType == 'subscription' && this.form.querySelector('recharge-widget custom-select ul li input') ? this.form.querySelector('recharge-widget custom-select ul li input').getAttribute('data-discount') : 0;
          discountPercentage = parseFloat(dis) || 0;
        }
      } 

      if(currentVariant.options.length == 1 && container.querySelector('.custom-plan-wrapper[data-optionindex="1"]') != null) {
        if(currentVariant.metafields != null) {
          container.querySelectorAll('[data-size-desc]').forEach(x => x.textContent = `${currentVariant.metafields.serving_capacity}${ currentVariant.metafields.product_size_description ? `(${currentVariant.metafields.product_size_description})` : ''}`);
        }

        this.variantData.forEach((x) => {
            let regularP = x.price;
            let compareP = x.compare_at_price;
            
            // Use actual selling plan allocation price instead of calculating it
            let displayPrice = regularP;
            if (planType == 'subscription' && x.selling_plan_allocations && x.selling_plan_allocations.length > 0) {
              displayPrice = x.selling_plan_allocations[0].price;
            } else if (planType == 'subscription') {
              // Fallback to manual calculation if selling plan data not available
              displayPrice = regularP - (regularP * discountPercentage / 100);
              displayPrice = Math.round(displayPrice);
            }
            
            let discountPercent = Math.floor(((compareP - displayPrice) / compareP) * 100); // Calculate discount percentage based on difference between compare at compare at price and discounted price from RC 

            container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-grp-price]`).setAttribute('data-regular-price', x.price);
            container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-grp-price]`).textContent = Utility.formatMoney(displayPrice, window.globalVariables.money_format);
            container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-grp-com-price]`).textContent = x.compare_at_price > x.price ? Utility.formatMoney(x.compare_at_price, window.globalVariables.money_format) : '';

            container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-variant-discount]`).innerHTML = discountPercentage+"%";

            if(compareP < regularP) {
              container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-variant-discount-percent]`).innerHTML = discountPercentage +"%";
            }else{
              container.querySelector(`[data-optionindex="1"] ul li label[title="${x.option1}"] [data-variant-discount-percent]`).innerHTML = discountPercent +"%";
            }

          });

      } else {
        if(currentVariant.metafields != null)
          container.querySelectorAll('[data-size-desc]').forEach(x => x.textContent = `${currentVariant.metafields.serving_capacity}${ currentVariant.metafields.product_size_description ? `(${currentVariant.metafields.product_size_description})` : ''}`);
  
        if(container.querySelector('[data-optionindex="2"]')){
  
          this.currentVariantGroup.forEach((x) => {
            container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-grp-price]`).setAttribute('data-regular-price', x.price);
            container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-grp-com-price]`).textContent = x.compare_at_price > x.price ? Utility.formatMoney(x.compare_at_price, window.globalVariables.money_format) : '';
            container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-grp-size]`).textContent = x.metafields.product_size_description ? `(${x.metafields.product_size_description})` : '';
  
            if(planType == 'subscription' ){
              let regularP = x.price;
              
              // Use actual selling plan allocation price instead of calculating it
              let displayPrice = regularP;
              if (x.selling_plan_allocations && x.selling_plan_allocations.length > 0) {
                displayPrice = x.selling_plan_allocations[0].price;
              } else {
                // Fallback to manual calculation if selling plan data not available
                displayPrice = regularP - (regularP * discountPercentage / 100);
                displayPrice = Math.round(displayPrice);
              }
              
              container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-variant-discount]`).innerHTML = discountPercentage+"%";
              container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-grp-price]`).textContent = Utility.formatMoney(displayPrice, window.globalVariables.money_format);
            } else {
              container.querySelector(`[data-optionindex="2"] ul li label[title="${x.option2}"] [data-grp-price]`).textContent = Utility.formatMoney(x.price, window.globalVariables.money_format);
            }
             
          });
        }
      }

    }

    // Handle both case variations of data-currentPrice for the check
    const priceElement = container.querySelector('[data-currentPrice]') || container.querySelector('[data-currentprice]');
    if (priceElement) {
      this.priceUpdate(currentVariant, container);
    }

    if(this.formType == 'product-page' && eventType != 'load'){
      this.renderIngredients(currentVariant, container);
    }
    
  }

  renderIngredients(currentVariant, container) {
    if(document.querySelector('[data-product-ingredients]') != null){
      const $el = document.querySelector('[data-product-ingredients]');
      if(currentVariant.metafields.ingredients.heading != ""){
        $el.querySelector('[data-ing-heading]').innerHTML = currentVariant.metafields.ingredients.heading;
      }

      if(currentVariant.metafields.ingredients.title != ""){
        $el.querySelector('[data-ing-title]').innerHTML = currentVariant.metafields.ingredients.title;
      }

      if(currentVariant.metafields.ingredients.sub_text != ""){
        $el.querySelector('[data-ing-sub-text]').innerHTML = currentVariant.metafields.ingredients.sub_text;
      }

      if(currentVariant.metafields.ingredients.image != "null"){
        $el.querySelector('[data-ing-img]').innerHTML = `<div class="d-block w-100 h-100">
            <img
              src="${currentVariant.metafields.ingredients.image}"
              data-src="${currentVariant.metafields.ingredients.image}"
              alt="${currentVariant.metafields.ingredients.name}"
              class="w-100"
            >
          </div>`;

          // $el.querySelector('[data-ing-img] #bubs_ingredients_image').dispatchEvent(new Event('click'));
      }

      if(currentVariant.metafields.ingredients_list_item.length > 0 ){
        const html = currentVariant.metafields.ingredients_list_item.map(item => `
          <div class="d-flex flex-wrap mb-4 ingredients_card">
          ${item.image != null ? `<div class="ingredients_image">
                <img src="${item.image}" alt="${item.title}" width="250" height="250" loading="eager" class="img-contain">
            </div>` : '' }
            <div class="ingredients_details ps-xl-4 ps-3 ">
              <h3 class="fw-light h3 ls-0 mb-2 text-uppercase">${item.title}</h3>
              <div class="desc d-none d-sm-block">${item.caption}</div>
            </div>
            <div class="desc mt-2 d-block d-sm-none">${item.caption}</div>
          </div>
        `).join('');
        $el.querySelector('[data-ingredients-lists]').innerHTML = html;
      }
    }
  }

  /**
   * Toggle the button based on product availability ( add to cart / soldOut )
   * @param {*} status enable / disable
   */
  toggleAddButton(status) {
    if (!this.addBtn) return;
    
    // Check if variant should be forced out of stock or is unavailable
    const forceOutOfStock = this.currentVariant?.metafields?.force_out_of_stock === true;
    const isUnavailable = !this.currentVariant?.available;
    const shouldDisable = forceOutOfStock || isUnavailable;
    
    // if product is not available disable the add to cart button and update the text
    if (status == 'disable' || shouldDisable) {
      this.addBtn.setAttribute('disabled', true);
      this.addBtn.setAttribute('reyjay', 'testing1');
      
      // Determine the appropriate text based on the reason for being disabled
      let disabledText;
      if (forceOutOfStock || isUnavailable) {
        disabledText = window.variantStrings.soldOut;
      } else {
        disabledText = window.variantStrings.unavailable;
      }
      
      if(this.addBtn.querySelector('.add-text'))
        this.addBtn.querySelector('.add-text').textContent = disabledText;

      document.querySelectorAll('[data-atc-out]')?.forEach(ele => {
        ele.setAttribute('disabled', true);
        ele.innerHTML = disabledText;
      });
    } else {
      this.addBtn.removeAttribute('disabled');
      this.addBtn.removeAttribute('reyjay'); // Remove the testing attribute

      let price = Utility.formatMoney(this.currentVariant.price, window.globalVariables.money_format);
      document.querySelector('[data-product-container] recharge-widget')?.querySelectorAll('.widget-options').forEach((ele)=>{
        if(ele.querySelector('input').checked){
          if(ele.querySelector('input').getAttribute('data-type') == 'subscribe-only'){
            price = ele.querySelector('label [data-subscription_price]').textContent;
          } else {
            price = ele.querySelector('label [data-onetime-price]').textContent;
          }
        }
      });

      this.addBtn.querySelector('.add-text').innerHTML = `${window.variantStrings.addToCart} <span class="font-family-heading ls-0 lh-1"> <span class="mx-2">|</span> ${price} (per shipment)</span>`;
      document.querySelectorAll('[data-atc-out]')?.forEach(ele => {
        ele.removeAttribute('disabled');
        ele.innerHTML = `<span class="add-text 2">${window.variantStrings.addToCart}<span class="font-family-heading ls-0 lh-1"> <span class="mx-2">|</span>${price} (per shipment)</span></span><span class="spinner-border block__add-to-cart-spinner"></span>`;
      });
    }
  }

  /**
   * Show loading state by hiding gallery
   */
  showLoader() {
    const imageGallery = document.querySelector('.product-images-wrapper');
    if(imageGallery) {
      imageGallery.classList.remove('loader-ready');
    }
  }

  /**
   * Hide loading state by showing gallery
   */
  hideLoader() {
    const imageGallery = document.querySelector('.product-images-wrapper');
    if(imageGallery) {
      imageGallery.classList.add('loader-ready');
    }
  }

  /**
   * Handle URL variant parameter to show correct images on page load
   */
  handleUrlVariantParameter() {
    const urlParams = new URLSearchParams(window.location.search);
    const variantId = urlParams.get('variant');
    
    if(variantId) {
      // Find the variant by ID and update image visibility
      const variants = this._getVariantData();
      const selectedVariant = variants.find(variant => variant.id == variantId);
      
      if(selectedVariant) {
        this.updateVariantImageVisibility(selectedVariant);
      }
    }
  }

  /**
   * Handle single-variant products to default to second image if metafield is set
   */
  handleSingleVariantSecondImage() {
    // Check if this is a single-variant product (has only default variant)
    const productContainer = document.querySelector('[data-product-container]');
    const isSingleVariant = productContainer && productContainer.closest('.main-product-container').classList.contains('only-default-variant');
    
    
    if (isSingleVariant) {
      // Keep gallery hidden until we determine which image to show
      const imageGallery = document.querySelector('.product-images-wrapper');
      if (imageGallery) {
        imageGallery.classList.remove('loader-ready');
      }
      
      // Function to check and apply second image logic
      const applySecondImageLogic = () => {
        
        if (this.currentVariant && 
            this.currentVariant.metafields && 
            this.currentVariant.metafields.use_second_image_for_primary === true &&
            productSlider && 
            productSlider.slides && 
            productSlider.slides.length > 1) {
          
          // Default to second image (index 1) for single-variant products
          productSlider.slideTo(1, 0);
          
          // Show gallery after setting the correct slide
          if (imageGallery) {
            imageGallery.classList.add('loader-ready');
          }
          return true;
        } else {
          
          // Show gallery normally (first image) if metafield is not set
          if (imageGallery) {
            imageGallery.classList.add('loader-ready');
          }
        }
        return false;
      };
      
      // Try immediately
      if (!applySecondImageLogic()) {
        // If variant data not ready, try with delays
        setTimeout(() => {
          if (!applySecondImageLogic()) {
            setTimeout(() => {
              applySecondImageLogic();
            }, 300);
          }
        }, 200);
      }
    }
  }

  /**
   * Update variant image visibility by removing and storing DOM elements
   * @param {object} currentVariant 
   */
  updateVariantImageVisibility(currentVariant) {
    if(!productSlider) {
      // Skip waiting and go directly to fallback method for faster response
      this.processVariantImagesWithoutSwiper(currentVariant);
      return;
    }
    
    this.processVariantImages(currentVariant);
  }

  processVariantImages(currentVariant) {
    // Get the current variant's handle (first option value)
    const currentVariantHandle = currentVariant.options[0] ? currentVariant.options[0].toLowerCase().replace(/\s+/g, '-') : null;
    
    // Create storage container if it doesn't exist
    let storageContainer = document.getElementById('variant-image-storage');
    if(!storageContainer) {
      storageContainer = document.createElement('div');
      storageContainer.id = 'variant-image-storage';
      storageContainer.style.display = 'none';
      document.body.appendChild(storageContainer);
    }
    
    // Get all variant images (images with data-variant-handle attribute)
    const allVariantImages = document.querySelectorAll('.product--media[data-variant-handle]');
    
    // Remove all variant images from slider and store them
    allVariantImages.forEach(image => {
      image.remove();
      storageContainer.appendChild(image);
    });
    
    // Add current variant's images back to the beginning of the slider
    if(currentVariantHandle) {
      const currentVariantImages = storageContainer.querySelectorAll(`.product--media[data-variant-handle="${currentVariantHandle}"]`);
      const swiperWrapper = document.querySelector('.swiper-wrapper');
      
      currentVariantImages.forEach((image, index) => {
        // Insert at the beginning (index 0) or after existing non-variant images
        const insertPosition = index;
        if(swiperWrapper.children[insertPosition]) {
          swiperWrapper.insertBefore(image, swiperWrapper.children[insertPosition]);
        } else {
          swiperWrapper.appendChild(image);
        }
      });
    }
    
    // Update Swiper and slide to first slide
    productSlider.update();
    productSlider.slideTo(0, 0);
    
    // Hide loader after variant images are set up
    this.hideLoader();
  }

  processVariantImagesWithoutSwiper(currentVariant) {
    // Get the current variant's handle (first option value)
    const currentVariantHandle = currentVariant.options[0] ? currentVariant.options[0].toLowerCase().replace(/\s+/g, '-') : null;
    
    // Create storage container if it doesn't exist
    let storageContainer = document.getElementById('variant-image-storage');
    if(!storageContainer) {
      storageContainer = document.createElement('div');
      storageContainer.id = 'variant-image-storage';
      storageContainer.style.display = 'none';
      document.body.appendChild(storageContainer);
    }
    
    // Get all variant images (images with data-variant-handle attribute)
    const allVariantImages = document.querySelectorAll('.product--media[data-variant-handle]');
    
    // Remove all variant images from slider and store them
    allVariantImages.forEach(image => {
      image.remove();
      storageContainer.appendChild(image);
    });
    
    // Add current variant's images back to the beginning of the slider
    if(currentVariantHandle) {
      const currentVariantImages = storageContainer.querySelectorAll(`.product--media[data-variant-handle="${currentVariantHandle}"]`);
      const swiperWrapper = document.querySelector('.swiper-wrapper');
      
      currentVariantImages.forEach((image, index) => {
        // Insert at the beginning (index 0) or after existing non-variant images
        const insertPosition = index;
        if(swiperWrapper.children[insertPosition]) {
          swiperWrapper.insertBefore(image, swiperWrapper.children[insertPosition]);
        } else {
          swiperWrapper.appendChild(image);
        }
      });
    }
    
    // Hide loader after variant images are set up (without Swiper updates)
    this.hideLoader();
  }

  /**
   * Store the all the variants json
   */
  _getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.variant_json.textContent);

    if(this.variantData) {
      this.variant_metafield_json = this.variant_metafield_json || JSON.parse(this.variant_metafield.textContent);
      
      this.variantData.forEach((x) => {
        x.metafields = this.variant_metafield_json[x.id];
      });
    }

    return this.variantData;
  }

  /**
   * Display first order pricing with metafield override
   * @param {element} firstOrderPricingElement 
   * @param {object} firstAllocation 
   * @param {object} currentVariant 
   * @param {number} futureOrderDiscount 
   */
  _displayFirstOrderPricingWithOverride(firstOrderPricingElement, firstAllocation, currentVariant, futureOrderDiscount) {
    const firstOrderPrice = firstAllocation.price_adjustments[0].price;
    const originalPrice = currentVariant.compare_at_price || currentVariant.price;
    
    // Calculate future order price using the metafield discount percentage
    const discountDecimal = parseInt(futureOrderDiscount) / 100;
    const calculatedFutureOrderPrice = originalPrice - (originalPrice * discountDecimal);
    
    // Calculate discount percentages
    const firstDiscountPercent = Math.round(((originalPrice - firstOrderPrice) / originalPrice) * 100);
    const futureDiscountPercent = parseInt(futureOrderDiscount);
    
    // Update the pricing block with metafield override
    firstOrderPricingElement.innerHTML = `
      First order <span class="first-order-price fw-bold">${Utility.formatMoney(firstOrderPrice, window.globalVariables.money_format)} (${firstDiscountPercent}% off)</span>, 
      then <span class="secondary-order-price fw-bold">${Utility.formatMoney(calculatedFutureOrderPrice, window.globalVariables.money_format)} (${futureDiscountPercent}% off)</span> future orders
    `;
    
    // Show the element
    firstOrderPricingElement.style.display = '';
  }

  /**
   * Display first order pricing using normal Recharge logic
   * @param {element} firstOrderPricingElement 
   * @param {object} firstAllocation 
   * @param {object} currentVariant 
   */
  _displayFirstOrderPricingNormal(firstOrderPricingElement, firstAllocation, currentVariant) {
    const firstOrderPrice = firstAllocation.price_adjustments[0].price;
    const futureOrderPrice = firstAllocation.price_adjustments[1].price;
    const originalPrice = currentVariant.compare_at_price || currentVariant.price;
    
    // Only show pricing block if first order has a discount
    if (firstOrderPrice < futureOrderPrice) {
      // Calculate discount percentages
      const firstDiscountPercent = Math.round(((originalPrice - firstOrderPrice) / originalPrice) * 100);
      const futureDiscountPercent = Math.round(((originalPrice - futureOrderPrice) / originalPrice) * 100);
      
      // Update the pricing block
      firstOrderPricingElement.innerHTML = `
        First order <span class="first-order-price fw-bold">${Utility.formatMoney(firstOrderPrice, window.globalVariables.money_format)} (${firstDiscountPercent}% off)</span>, 
        then <span class="secondary-order-price fw-bold">${Utility.formatMoney(futureOrderPrice, window.globalVariables.money_format)} (${futureDiscountPercent}% off)</span> future orders
      `;
      
      // Show the element
      firstOrderPricingElement.style.display = '';
    } else {
      // First order same as recurring - hide the element
      firstOrderPricingElement.style.display = 'none';
    }
  }
}
customElements.define('variant-selects', VariantSelects);

/**
 * Radio Button swatch
 */
class VariantRadios extends VariantSelects {
  constructor() {
    super();

    this.form = this.closest('form') || this.querySelector('.form-element');
    this.formType = this.form.dataset.format;

    const colorSwatchContainer = this.querySelector('.color-swatch');
    if(colorSwatchContainer){
      const colorSwatches = colorSwatchContainer.querySelectorAll('.swatch');
      colorSwatches.forEach(swatch => {
        let colorHandle = swatch.querySelector('input[type="radio"]').dataset.handle;
        let swatchStyle = Utility.getSwatchStyle(colorHandle);
        swatch.querySelector('.swatch-label').setAttribute('style', swatchStyle);
      });
    }
  }
  
  connectedCallback() {
    super.connectedCallback();
    
    // Add explicit event listeners for radio button changes
    this.querySelectorAll('input[type="radio"]').forEach(radio => {
      radio.addEventListener('change', (event) => {
        if (event.target.checked) {
          // Trigger the variant change event
          this.onVariantChange(event);
        }
      });
    });
  }
}
customElements.define('variant-radios', VariantRadios);

class rechargeWidget extends HTMLElement {
  constructor() {
    super();
    
    this.optionSelectors = this.querySelectorAll('[data-purchase_type]');
    this.optionSelectors.forEach(option => option.addEventListener('click', this._toggleOptions.bind(this)));

    this.sellingPlans = this.querySelectorAll('[data-purchase_type="subscription"] .custom-dropdown');
    this.sellingPlans.forEach(plan => plan.addEventListener('change', this._changeSellingPlan.bind(this)));

    // Add direct click handler for dropdown options
    this.addEventListener('click', (event) => {
      const target = event.target;
      let optionItem = target.closest('li');
      let optionText = null;
      let customSelect = null;

      // Handle radio input clicks
      if (target.matches('input[type="radio"]')) {
        const purchaseType = target.closest('[data-purchase_type]');
        if (purchaseType) {
          const optionTxt = purchaseType.querySelector('.option_txt');
          if (optionTxt) {
            optionText = optionTxt;
            customSelect = purchaseType.querySelector('custom-select');
          }
        }
      } 
      // Handle list item clicks
      else if (optionItem) {
        customSelect = optionItem.closest('custom-select');
        if (customSelect) {
          optionText = customSelect.querySelector('.option_txt');
        }
      }

      if (!optionText || !customSelect) return;

      // Update text content
      if (optionItem) {
        optionText.textContent = optionItem.getAttribute('data-value');
        
        // Update selected state
        customSelect.querySelectorAll('li').forEach(li => li.classList.remove('selected'));
        optionItem.classList.add('selected');
        
        // Update radio input
        const radioInput = optionItem.querySelector('input[type="radio"]');
        if (radioInput) {
          radioInput.checked = true;
          radioInput.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    });
  }

  connectedCallback() {
    // Initialize data for single-variant products (multi-variant products are handled by VariantSelects)
    setTimeout(() => {
      if (!this.closest('form').querySelector('variant-selects')) {
        this.initializeSingleVariantProduct();
      }
    }, 50);
    
    // Call _toggleOptions on page load to set initial discount percentages
    setTimeout(() => {
      const mockEvent = { target: this.querySelector('input[type="radio"]:checked') || this.querySelector('input[type="radio"]') };
      if (mockEvent.target) {
        this._toggleOptions(mockEvent);
      }
      
      // Filter selling plans on initial load
      this.filterSellingPlansForVariant();
    }, 100);
    
  }

  initializeSingleVariantProduct() {
    const form = this.closest('form');
    let currentVariant = window.globalVariables?.product?.currentVariant;
    
    // For single-variant products, get variant from product data if not set
    if (!currentVariant && window.globalVariables?.product?.variants) {
      currentVariant = window.globalVariables.product.variants[0];
      
      // Get metafields from the DOM JSON script for single-variant products
      const metafieldsScript = form.querySelector('[data-variantJSON-metafields]');
      if (metafieldsScript && metafieldsScript.textContent) {
        try {
          const variantMetafields = JSON.parse(metafieldsScript.textContent);
          const variantId = currentVariant.id.toString();
          if (variantMetafields[variantId]) {
            currentVariant.metafields = variantMetafields[variantId];
          }
        } catch (error) {
          // Silently continue if metafields can't be parsed
        }
      }
      
      // Set it globally so other code can use it
      if (!window.globalVariables.product.currentVariant) {
        window.globalVariables.product.currentVariant = currentVariant;
      }
    }
    
    if (!currentVariant) {
      return;
    }
    
    // Populate data-onetime-price elements (same logic as VariantSelects)
    form.querySelectorAll('[data-onetime-price]').forEach((ele) => {
      ele.innerHTML = Utility.formatMoney(currentVariant.price, window.globalVariables.money_format);
      
      // Set onetime_compare_price attribute - check selling_plan_allocations first, then compare_at_price
      let comparePrice = null;
      if (currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0) {
        comparePrice = currentVariant.selling_plan_allocations[0].compare_at_price;
      } else if (currentVariant.compare_at_price != null) {
        comparePrice = currentVariant.compare_at_price;
      }
      
      if (comparePrice != null) {
        let onetime_com_price = Utility.formatMoney(comparePrice, window.globalVariables.money_format);
        ele.setAttribute("onetime_compare_price", onetime_com_price);
      }
    });

    // Populate data-subscription_price elements
    form.querySelectorAll('[data-subscription_price]').forEach((ele) => {
      if (currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0) {
        let subscription_price = Utility.formatMoney(currentVariant.selling_plan_allocations[0].price, window.globalVariables.money_format);
        ele.innerHTML = subscription_price;
        
        if (currentVariant.selling_plan_allocations[0].compare_at_price) {
          let subscription_compare = Utility.formatMoney(currentVariant.selling_plan_allocations[0].compare_at_price, window.globalVariables.money_format);
          ele.setAttribute("subscription_compare_price", subscription_compare);
        }
      }
    });

    // Handle first order pricing for single-variant products
    const firstOrderPricingElement = form.querySelector('[data-first-order-pricing]');
    if (firstOrderPricingElement && currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0) {
      const firstAllocation = currentVariant.selling_plan_allocations[0];
      
      // Check for metafield override first
      const futureOrderDiscount = currentVariant.metafields?.future_order_hardcoded_discount;
      
      if (futureOrderDiscount) {
        // Use metafield override - calculate the future order price based on the discount percentage
        const firstOrderPrice = firstAllocation.price_adjustments[0].price;
        const originalPrice = currentVariant.compare_at_price || currentVariant.price;
        
        // Calculate future order price using the metafield discount percentage
        const discountDecimal = parseInt(futureOrderDiscount) / 100;
        const calculatedFutureOrderPrice = originalPrice - (originalPrice * discountDecimal);
        
        // Calculate discount percentages
        const firstDiscountPercent = Math.round(((originalPrice - firstOrderPrice) / originalPrice) * 100);
        const futureDiscountPercent = parseInt(futureOrderDiscount);
        
        // Update the pricing block with metafield override
        firstOrderPricingElement.innerHTML = `
          First order <span class="first-order-price fw-bold">${Utility.formatMoney(firstOrderPrice, window.globalVariables.money_format)} (${firstDiscountPercent}% off)</span>, 
          then <span class="secondary-order-price fw-bold">${Utility.formatMoney(calculatedFutureOrderPrice, window.globalVariables.money_format)} (${futureDiscountPercent}% off)</span> future orders
        `;
        
        // Show the element
        firstOrderPricingElement.style.display = '';
      } else if (firstAllocation.price_adjustments && firstAllocation.price_adjustments.length >= 2) {
        // Use normal Recharge logic
        const firstOrderPrice = firstAllocation.price_adjustments[0].price;
        const futureOrderPrice = firstAllocation.price_adjustments[1].price;
        const originalPrice = currentVariant.compare_at_price || currentVariant.price;
        
        // Only show pricing block if first order has a discount
        if (firstOrderPrice < futureOrderPrice) {
          // Calculate discount percentages
          const firstDiscountPercent = Math.round(((originalPrice - firstOrderPrice) / originalPrice) * 100);
          const futureDiscountPercent = Math.round(((originalPrice - futureOrderPrice) / originalPrice) * 100);
          
          // Update the pricing block
          firstOrderPricingElement.innerHTML = `
            First order <span class="first-order-price fw-bold">${Utility.formatMoney(firstOrderPrice, window.globalVariables.money_format)} (${firstDiscountPercent}% off)</span>, 
            then <span class="secondary-order-price fw-bold">${Utility.formatMoney(futureOrderPrice, window.globalVariables.money_format)} (${futureDiscountPercent}% off)</span> future orders
          `;
          
          // Show the element
          firstOrderPricingElement.style.display = '';
        } else {
          // First order same as recurring - hide the element
          firstOrderPricingElement.style.display = 'none';
        }
      } else {
        // No price adjustments - hide the element
        firstOrderPricingElement.style.display = 'none';
      }
    }

  }

  _toggleOptions(event){
    this.form = event.target.closest('form');
    
    if (this.form.closest('[data-product-container]') && this.form.querySelector('recharge-widget')) {
      this.type = this.form.querySelector('[name="selling_plan"]:checked')?.closest('[data-purchase_type]')?.getAttribute('data-purchase_type');
    }
    
    // Get current button state
    const currentButton = this.form.closest('[data-product-container]').querySelector('[name="add"]');
    const isSoldOut = currentButton?.disabled || currentButton?.querySelector('.add-text')?.textContent.includes(window.variantStrings.soldOut);

    if (this.type == 'onetime') {
      // Get current variant to ensure we use the latest variant's pricing
      const currentVariant = window.globalVariables?.product?.currentVariant;
      const onetimePriceElement = this.form.querySelector('[data-onetime-price]');
      const currentPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-currentprice]');
      
      // Declare onetime_price outside the if block to fix scope issue
      let onetime_price = '';
      if (onetimePriceElement && currentPriceElement) {
        onetime_price = onetimePriceElement.innerHTML;
        currentPriceElement.innerHTML = onetime_price;
      }

      // Use current variant's compare_at_price instead of potentially stale attribute
      let onetime_compare_price = '';
      if (currentVariant && currentVariant.compare_at_price) {
        onetime_compare_price = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      } else {
        // Fallback to attribute if no current variant
        onetime_compare_price = this.form.querySelector('[data-onetime-price]')?.getAttribute("onetime_compare_price") || '';
      }
      
      const comparePriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-current-com-price]');
      if (comparePriceElement) {
        comparePriceElement.innerHTML = onetime_compare_price;
      }
      
      // Check if there's a real discount (compare price > regular price)
      // Only proceed if onetime_price is available
      if (onetime_price) {
        const onetimePriceValue = parseFloat(onetime_price.replace(/[^0-9.-]+/g, ""));
        const onetimeComparePriceValue = onetime_compare_price ? parseFloat(onetime_compare_price.replace(/[^0-9.-]+/g, "")) : 0;
        const hasRealDiscount = onetime_compare_price && onetime_compare_price.length > 0 && onetimeComparePriceValue > onetimePriceValue;
        
        const compareOutPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-current-com-price]');
        
        if (hasRealDiscount) {
          // Show discount styling: red text and crossed-out compare price
          if (currentPriceElement) {
            currentPriceElement.classList.add('text-danger');
          }
          if (compareOutPriceElement) {
            compareOutPriceElement.style.display = '';
          }
        } else {
          // No real discount: remove red styling and hide crossed-out price
          if (currentPriceElement) {
            currentPriceElement.classList.remove('text-danger');
          }
          if (compareOutPriceElement) {
            compareOutPriceElement.style.display = 'none';
          }
        }
      }

      // Create button text based on sold out state
      const buttonText = isSoldOut 
        ? window.variantStrings.soldOut
        : `${window.variantStrings.addToCart} <span class="font-family-heading ls-0 lh-1"> <span class="mx-2">|</span> ${onetime_price || 'N/A'} (per shipment)</span>`;

      // Update main add to cart button
      const addButton = this.form.closest('[data-product-container]')?.querySelector('[name="add"]');
      const addButtonText = addButton?.querySelector('.add-text');
      
      if (addButtonText) {
        addButtonText.innerHTML = buttonText;
      }
      if (addButton) {
        addButton.disabled = isSoldOut;
      }

      // Update sticky add to cart buttons
      document.querySelectorAll('[data-atc-out]')?.forEach(ele => {
        ele.innerHTML = `<span class="add-text">${buttonText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
        ele.disabled = isSoldOut;
      });

      // Update sticky product details button
      const stickyButton = document.querySelector('.product-sticky-container [data-atc-out]');
      if (stickyButton) {
        stickyButton.innerHTML = `<span class="add-text">${buttonText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
        stickyButton.disabled = isSoldOut;
      }

      let $variantGRP = null;
      $variantGRP = this.form.querySelectorAll('.custom-plan-wrapper > ul > li');

      if($variantGRP != null){
        $variantGRP.forEach((x) => {

          let regularP = x.querySelector('label [data-grp-price]').getAttribute('data-regular-price');
          let comparePrice = x.querySelector("label [data-grp-com-price]").getAttribute("data-regular-com-price");

          // Check if there's a meaningful discount difference
          const discountWrapper = x.querySelector(".discount-wrapper");
          if (discountWrapper) {
            const firstAdjustment = discountWrapper.getAttribute("data-first-adjustment");
            const secondAdjustment = discountWrapper.getAttribute("data-second-adjustment");
            var hasFirstOrderPrice = firstAdjustment !== secondAdjustment;
          }
          
          x.querySelector('label [data-grp-price]').textContent = Utility.formatMoney(regularP, window.globalVariables.money_format);
          if(x.querySelector(".dynamic-sales-message")){
            x.querySelector(".dynamic-sales-message").classList.add("d-none"); // hide the dynamic sales message
          }

          if(comparePrice != ''){
            x.querySelector("label [data-grp-com-price]").classList.remove("d-none");
            const subscriptionMessage = x.querySelector("label .subscription-message");
            if (subscriptionMessage) {
              subscriptionMessage.classList.add("d-none");
            }
            // we need to have something that still shows the sale
            x.querySelector("label [data-grp-com-price]").textContent = Utility.formatMoney(comparePrice, window.globalVariables.money_format);
          } else {
            x.querySelector("label [data-grp-com-price]").classList.add("d-none");
          }

          // Update data-variant-discount-percent for onetime (compare price discount only)
          let comparePriceValue = parseFloat(comparePrice || 0);
          let regularPriceValue = parseFloat(regularP);
          
          if(comparePriceValue > regularPriceValue) {
            let compareDiscountPercent = Math.floor(((comparePriceValue - regularPriceValue) / comparePriceValue) * 100);
            x.querySelector('label [data-variant-discount-percent]').innerHTML = compareDiscountPercent + "%";
            
            // x.querySelector(".discount-percentage-price-value").classList.remove("d-none");
          } else {
            x.querySelector('label [data-variant-discount-percent]').innerHTML = "0%";
            // x.querySelector(".discount-percentage-price-value").classList.add("d-none"); // hide the dynamic sales message
          }

          // Triggers on one time click
          if(comparePriceValue > regularPriceValue){
            x.querySelector(".discount-wrapper").classList.remove("d-none");
          }else{
            x.querySelector(".discount-wrapper").classList.add("d-none");
          }
          
        });
      }

  // Update shipping text for onetime products (in case single-variant products default to onetime)
  const shippingTextElement = this.form.querySelectorAll('[data-shipping-text]');
  
  
  
  if (shippingTextElement) {
    // For onetime, use current variant's compare price instead of potentially stale attribute
    const currentVariant = window.globalVariables?.product?.currentVariant;
    let comparePrice = 0;
    
    if (currentVariant && currentVariant.compare_at_price) {
      comparePrice = currentVariant.compare_at_price;
    } else {
      // Fallback to attribute if no current variant
      const regPrice = currentVariant.price;
      
      const onetimePriceElement = this.form.querySelector('[data-onetime-price]');
      const comparePriceAttr = onetimePriceElement?.getAttribute("onetime_compare_price");
      comparePrice = comparePriceAttr ? parseFloat(comparePriceAttr.replace(/[^0-9.-]+/g, "")) * 100 : 0;
    }
    
    if (currentVariant && comparePrice > 0) {
      const currentVariantPrice = currentVariant.selling_plan_allocations[0].price;
      const comparePriceDiscount = comparePrice - currentVariantPrice;
      const ship_rate = currentVariant.metafields?.shipping_rate * 100 || 0;
      
      if (ship_rate > 0) {
        const totalSavingsPercentage = Math.floor(((comparePrice - currentVariantPrice) / comparePrice) * 100);
        const totalDis = Utility.formatMoney((comparePriceDiscount + ship_rate), window.globalVariables.money_format);
        shippingTextElement.forEach(element => {
          element.innerHTML = `${totalSavingsPercentage}% off + Free Shipping*<br/> ${totalDis} Total Savings`;
        });
      } else {
        shippingTextElement.forEach(element => {
          element.innerHTML = ' ';
        });
      }
    } else {
      shippingTextElement.innerHTML = ' ';
    }

       // Change the price of the subscription discount on change of supply
       const planComparePriceObj = document.querySelector('input[type="radio"][name="Supply"]:checked')?.closest('li').querySelector('[data-plan-com-price]')?.getAttribute('data-plan-com-price');
       const onetimePriceElement = document.querySelector('[data-onetime-pricen]');
       
       if(onetimePriceElement && planComparePriceObj) {
         onetimePriceElement.textContent = Utility.formatMoney(planComparePriceObj, window.globalVariables.money_format);
       }
    
  }

    }else{
      
      // this.form.querySelectorAll('[data-grp-com-price]').forEach((ele)=>{
      //   ele.classList.add('d-none');
      // });

      // Get current variant to ensure we use the latest variant's pricing
      const currentVariant = window.globalVariables?.product?.currentVariant;
      let subscription_price = this.form.querySelector('[data-subscription_price]').innerHTML;
      this.form.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = subscription_price;
      
      // Use current variant's selling_plan_allocations compare_at_price instead of potentially stale attribute
      let subscription_compare_price = '';
      if (currentVariant && currentVariant.compare_at_price) {
        // For subscription products, use the original product compare_at_price, not the selling plan one
        subscription_compare_price = Utility.formatMoney(currentVariant.compare_at_price, window.globalVariables.money_format);
      } else if (currentVariant && currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0 && currentVariant.selling_plan_allocations[0].compare_at_price) {
        // Fallback to selling plan compare price only if no original compare price
        subscription_compare_price = Utility.formatMoney(currentVariant.selling_plan_allocations[0].compare_at_price, window.globalVariables.money_format);
      } else {
        // Fallback to attribute if no current variant
        subscription_compare_price = this.form.querySelector('[data-subscription_price]').getAttribute("subscription_compare_price") || '';
      }
      this.form.closest('[data-product-container]').querySelector('[data-current-com-price]').innerHTML = subscription_compare_price;

      // Update future subscription price (10% off compare_at_price)
      const futureSubscriptionPriceElement = document.querySelector('[data-future-subscription-price]');
      if (futureSubscriptionPriceElement) {
        // Use current variant's selling_plan_allocations compare_at_price instead of stale attribute
        let comparePrice = null;
        if (currentVariant && currentVariant.selling_plan_allocations && currentVariant.selling_plan_allocations.length > 0 && currentVariant.selling_plan_allocations[0].compare_at_price) {
          comparePrice = currentVariant.selling_plan_allocations[0].compare_at_price / 100; // Convert from cents to dollars
        } else if (currentVariant && currentVariant.compare_at_price) {
          comparePrice = currentVariant.compare_at_price / 100; // Convert from cents to dollars
        } else {
          // Fallback to attribute if no current variant
          const comparePriceText = this.form.querySelector('[data-onetime-price]').getAttribute("onetime_compare_price");
          if (comparePriceText && comparePriceText.length > 0) {
            comparePrice = parseFloat(comparePriceText.replace('$', '').replace(',', ''));
          }
        }
        
        if (comparePrice) {
          const futureSubscriptionPrice = comparePrice * 0.9; // 10% off compare price
          futureSubscriptionPriceElement.textContent = Utility.formatMoney(futureSubscriptionPrice * 100, window.globalVariables.money_format);
        }
      }

      // Update shipping text for subscription products
      const shippingTextElement = this.form.querySelectorAll('[data-shipping-text]');
      
      if (shippingTextElement) {
        // Get discount value from recharge widget
        const rechargeInput = this.form.querySelector('recharge-widget custom-select ul li input');
        
        const disV = rechargeInput ? parseFloat(rechargeInput.getAttribute('data-discount')) : 0;
        
        // Get current variant data first
        const currentVariant = window.globalVariables?.product?.currentVariant;
        
                 // Get the compare price (original price before any discounts)
         let comparePrice;
         if(currentVariant.compare_at_price && currentVariant.compare_at_price > currentVariant.price){
           // Use Shopify's compare_at_price if it's higher than current price (real discount)
           comparePrice = currentVariant.compare_at_price;
         } else {
           // Fall back to Recharge's compare_at_price
           comparePrice = currentVariant?.selling_plan_allocations?.[0]?.compare_at_price;
         }
         
         // Get the current subscription price
         const subscriptionPrice = currentVariant.selling_plan_allocations[0].price;
         
         // Calculate the percentage discount
         let discountPercentage = 0;
         if(comparePrice && comparePrice > subscriptionPrice) {
           discountPercentage = Math.floor(((comparePrice - subscriptionPrice) / comparePrice) * 100);
         }
         
          
          if (currentVariant) {
            // Calculate shipping rate
            let ship_rate = currentVariant.metafields?.shipping_rate * 100 || 0;
            
            
            let vPrice = comparePrice * disV / 100;  // Recharge discount
            
            
            if (comparePrice > 0) {
              // Get the actual subscription price (should be from selling_plan_allocations[0].price)
              const subscriptionPriceElement = this.form.querySelector('[data-subscription_price]');
              const subscriptionPriceText = subscriptionPriceElement ? subscriptionPriceElement.innerHTML : '';
            
              
              const subscriptionPrice = subscriptionPriceText ? parseFloat(subscriptionPriceText.replace('$', '').replace(',', '')) * 100 : currentVariant.price;
            
              
                           // Use the discount percentage we calculated above
             const totalSavingsPercentage = discountPercentage || disV;
            
              
              const comparePriceDiscount = comparePrice - subscriptionPrice;  // Savings from compare price to subscription price
            
              
              let totalDis = Utility.formatMoney((comparePriceDiscount + ship_rate), window.globalVariables.money_format);
              
              
            // Update shipping text
            if ((ship_rate + vPrice) > 0) {
              shippingTextElement.forEach(element => {
                element.innerHTML = `${totalSavingsPercentage}% off + Free Shipping*<br/> ${totalDis} Total Savings`;
              });
            } else {
              shippingTextElement.forEach(element => {
                shippingTextElement.innerHTML = ' ';
              });
            }
          } else if ((ship_rate + vPrice) > 0) {
            // No compare price, but show shipping/subscription savings if available
            let totalDis = Utility.formatMoney((ship_rate + vPrice), window.globalVariables.money_format);
            let discountText = [];
            if (vPrice > 0) discountText.push(`${disV}% subscription discount`);
            if (ship_rate > 0) discountText.push('Free Shipping*');
            
            shippingTextElement.innerHTML = `${discountText.join(' + ')}<br/> ${totalDis} Total Savings`;
          } else {
            shippingTextElement.innerHTML = ' ';
          }
        } else {
          shippingTextElement.innerHTML = ' ';
        }
      }

      // Check if there's a real discount (compare price > subscription price)
      const subscriptionPriceValue = parseFloat(subscription_price.replace(/[^0-9.-]+/g, ""));
      const subscriptionComparePriceValue = subscription_compare_price ? parseFloat(subscription_compare_price.replace(/[^0-9.-]+/g, "")) : 0;
      const hasRealSubscriptionDiscount = subscription_compare_price && subscription_compare_price.length > 0 && subscriptionComparePriceValue > subscriptionPriceValue;
      
      const subscriptionCurrentPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-currentprice]');
      const subscriptionCompareOutPriceElement = this.form.closest('[data-product-container]')?.querySelector('[data-current-com-price]');
      
      if (hasRealSubscriptionDiscount) {
        // Show discount styling: red text and crossed-out compare price
        if (subscriptionCurrentPriceElement) {
          subscriptionCurrentPriceElement.classList.add('text-danger');
        }
        if (subscriptionCompareOutPriceElement) {
          subscriptionCompareOutPriceElement.style.display = '';
        }
      } else {
        // No real discount: remove red styling and hide crossed-out price
        if (subscriptionCurrentPriceElement) {
          subscriptionCurrentPriceElement.classList.remove('text-danger');
        }
        if (subscriptionCompareOutPriceElement) {
          subscriptionCompareOutPriceElement.style.display = 'none';
        }
      }

      // Create button text based on sold out state
      const buttonText = isSoldOut 
        ? window.variantStrings.soldOut
        : `${window.variantStrings.addToCart} <span class="font-family-heading ls-0 lh-1"> <span class="mx-2">|</span> ${subscription_price} (per shipment)</span>`;

      // Update main add to cart button
      this.form.closest('[data-product-container]').querySelector('[name="add"] .add-text').innerHTML = buttonText;
      this.form.closest('[data-product-container]').querySelector('[name="add"]').disabled = isSoldOut;

      // Update sticky add to cart buttons
      document.querySelectorAll('[data-atc-out]')?.forEach(ele => {
        ele.innerHTML = `<span class="add-text">${buttonText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
        ele.disabled = isSoldOut;
      });

      // Update sticky product details button
      const stickyButton = document.querySelector('.product-sticky-container [data-atc-out]');
      if (stickyButton) {
        stickyButton.innerHTML = `<span class="add-text">${buttonText}</span><span class="spinner-border block__add-to-cart-spinner"></span>`;
        stickyButton.disabled = isSoldOut;
      }

      let $variantGRP = null;
      if(this.form.querySelector('[data-optionindex="2"]')){
        $variantGRP = this.form.querySelectorAll('[data-optionindex="2"] ul li');
      } else {
        $variantGRP = this.form.querySelectorAll('[data-optionindex="1"] ul li');
      }

      if($variantGRP != null){
        $variantGRP.forEach((x) => {
          const grpPriceElement = x.querySelector('label [data-grp-price]');
          const grpComPriceElement = x.querySelector('label [data-grp-com-price]');
          const rechargeInput = this.form.querySelector('recharge-widget custom-select ul li input');
          
          if (!grpPriceElement || !grpComPriceElement || !rechargeInput) return;
          
          let regularP = grpPriceElement.getAttribute('data-regular-price');
          let compareP = grpComPriceElement.getAttribute('data-regular-com-price');
          let dis = rechargeInput.getAttribute('data-discount') || 0;
          let discountPercentage = parseFloat(dis);
          
          // Get the actual variant data to access selling_plan_allocations
          const labelElement = x.querySelector('label');
          const variantTitle = labelElement ? labelElement.getAttribute('title') : null;
          
          // Find the corresponding variant from window.globalVariables or from variant data
          let displayPrice = regularP;
          if (variantTitle && window.globalVariables?.product?.variants) {
            const matchingVariant = window.globalVariables.product.variants.find(v => {
              // Match by option1 or option2 depending on which option this is
              return v.option1 === variantTitle || v.option2 === variantTitle;
            });
            
            if (matchingVariant && matchingVariant.selling_plan_allocations && matchingVariant.selling_plan_allocations.length > 0) {
              displayPrice = matchingVariant.selling_plan_allocations[0].price;
            } else {
              // Fallback to manual calculation if selling plan data not available
              displayPrice = regularP - (regularP * discountPercentage / 100);
              displayPrice = Math.round(displayPrice);
            }
          } else {
            // Fallback to manual calculation
            displayPrice = regularP - (regularP * discountPercentage / 100);
            displayPrice = Math.round(displayPrice);
          }
          
          let discountPercent = Math.floor(((compareP - displayPrice) / compareP) * 100);
      
          x.querySelector('label [data-grp-price]').textContent = Utility.formatMoney(displayPrice, window.globalVariables.money_format);
          x.querySelector("label [data-variant-discount]").innerHTML = discountPercentage+"%";

          // Check if there's a meaningful discount difference
          const discountWrapper = x.querySelector(".discount-wrapper");
          if (discountWrapper) {
            const firstAdjustment = discountWrapper.getAttribute("data-first-adjustment");
            const secondAdjustment = discountWrapper.getAttribute("data-second-adjustment");
            var hasFirstOrderPrice = firstAdjustment !== secondAdjustment;
          }

          if(compareP < regularP) {
            x.querySelector('label [data-variant-discount-percent]').innerHTML = discountPercentage + "%";
          }else{
            x.querySelector('label [data-variant-discount-percent]').innerHTML = discountPercent +"%";
          }

          // Triggers on subscription clickk
          if(hasFirstOrderPrice){
              x.querySelector(".discount-wrapper").classList.add("d-none");
          }else{
            x.querySelector(".discount-wrapper").classList.remove("d-none");
          }

          let plancomparePrice = x.querySelector("label [data-grp-com-price]").getAttribute("data-plan-com-price");
          if(plancomparePrice != ''){
            
            x.querySelector("label [data-grp-com-price]").classList.remove("d-none");
            const subscriptionMessage = x.querySelector("label .subscription-message");
            if(subscriptionMessage){
              subscriptionMessage.classList.remove("d-none");
            }

            x.querySelector("label [data-grp-com-price]").classList.remove("d-none");
            x.querySelector("label [data-grp-com-price]").textContent = Utility.formatMoney(plancomparePrice, window.globalVariables.money_format);

            if(x.querySelector(".dynamic-sales-message")){
            x.querySelector(".dynamic-sales-message").classList.remove("d-none"); // hide the dynamic sales message
            }
           
          }else{
            x.querySelector("label [data-grp-com-price]").classList.add("d-none");
            const subscriptionMessage = x.querySelector("label .subscription-message");
            if(subscriptionMessage){
              subscriptionMessage.classList.remove("d-none");
            }
            
          }
        });
        // Change the price of the subscription discount on change of supply
        const planComparePriceObj = document.querySelector('input[type="radio"][name="Supply"]:checked')?.closest('li').querySelector('[data-plan-com-price]')?.getAttribute('data-plan-com-price');
        const onetimePriceElement = document.querySelector('[data-onetime-pricen]');
        if(onetimePriceElement && planComparePriceObj) {
          onetimePriceElement.textContent = Utility.formatMoney(planComparePriceObj, window.globalVariables.money_format);
        }
      }

    }
  }

  /**
   * Filter selling plans based on current variant's available plans
   * This method will hide/show plan options based on what's available for the selected variant
   */
  filterSellingPlansForVariant() {
    const currentVariant = window.globalVariables?.product?.currentVariant;
    if (!currentVariant || !currentVariant.selling_plan_allocations) {
      return;
    }

    // Get all plan options in the recharge widget
    const planOptions = this.querySelectorAll('custom-select ul li');
    const availablePlanIds = currentVariant.selling_plan_allocations.map(allocation => allocation.selling_plan_id.toString());

    let hasVisiblePlans = false;
    let firstVisiblePlan = null;

    planOptions.forEach((li, index) => {
      const input = li.querySelector('input[type="radio"]');
      const planId = input?.value;
      const isAvailable = availablePlanIds.includes(planId);
      
      if (isAvailable) {
        li.style.display = '';
        li.classList.remove('d-none');
        if (!hasVisiblePlans) {
          hasVisiblePlans = true;
          firstVisiblePlan = li;
        }
      } else {
        li.style.display = 'none';
        li.classList.add('d-none');
        // Uncheck hidden plans
        if (input) {
          input.checked = false;
        }
      }
    });

    // If we have visible plans, select the first one if none are currently selected
    if (hasVisiblePlans && firstVisiblePlan) {
      const checkedInput = this.querySelector('custom-select ul li input:checked');
      if (!checkedInput || checkedInput.closest('li').style.display === 'none') {
        const firstInput = firstVisiblePlan.querySelector('input[type="radio"]');
        if (firstInput) {
          firstInput.checked = true;
          firstVisiblePlan.classList.add('selected');
          // Update the dropdown text
          const optionText = this.querySelector('.option_txt');
          if (optionText) {
            optionText.textContent = firstVisiblePlan.getAttribute('data-value');
          }
        }
      }
    }

    // Update the dropdown text to show the selected plan
    const selectedPlan = this.querySelector('custom-select ul li.selected');
    if (selectedPlan && selectedPlan.style.display !== 'none') {
      const optionText = this.querySelector('.option_txt');
      if (optionText) {
        optionText.textContent = selectedPlan.getAttribute('data-value');
      }
    }
  }

  _changeSellingPlan(event){
    let target = event.target;
    if (!target.closest('recharge-widget')) {
      target = event.target.closest('product-form')?.querySelector('recharge-widget custom-select ul li input');
    }
    
    let id = target.value;
    let dis = target.getAttribute('data-discount') || 0;
    
    let product_price = document.querySelector('[data-onetime-price]').innerHTML;
    let priceValue = parseFloat(product_price.replace('$', '').replace(',', ''));
    let discountPercentage = parseFloat(dis);
    let discountedPrice = priceValue - (priceValue * discountPercentage / 100);
    
    // Round to nearest cent to match Recharge/Shopify backend rounding
    discountedPrice = Math.round(discountedPrice * 100) / 100;
    
    target.closest('[data-purchase_type]').querySelector('[name="selling_plan"]').value=id;
    // target.closest('[data-purchase_type]').querySelector('[data-subscription_percentage]').innerHTML=`${dis}%`;
    target.closest('[data-purchase_type]').querySelector('[data-subscription_price]').innerHTML=`${Utility.formatMoney(discountedPrice*100, window.globalVariables.money_format)}`;
    target.closest('[data-product-container]').querySelector('[data-currentprice]').innerHTML = `${Utility.formatMoney(discountedPrice*100, window.globalVariables.money_format)}`
    target.closest('[data-product-container]').querySelector('[name="add"] .add-text').innerHTML = `${window.variantStrings.addToCart} <span class="font-family-heading ls-0 lh-1"> <span class="mx-2">|</span>${Utility.formatMoney(discountedPrice*100, window.globalVariables.money_format)} (per shipment)</span>`;

  }
}
customElements.define('recharge-widget', rechargeWidget);
